import { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import './CaseDismissedForm.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Navbar from './Navbar.js';
import header from './assets/images/header.jpg';


function CaseDismissedForm() {
    const moment = require('moment-timezone');
    const location = useLocation();
    const { language = 'en' } = location.state ?? {};

    const [surveyID, setSurveyID] = useState([]);
    const [questionList, setQuestionList] = useState([]);
    const [formValues, setFormValues] = useState({});

    const formElemRef = useRef(null);
    const [isSubmitted, setSubmitted] = useState(false);

    const buttonText = {
        en: { previous: 'Previous', submit: 'Submit' },
        ms: { previous: 'Sebelum', submit: 'Hantar' },
        zh: { previous: '上一页', submit: '提交' }
    };
    

    useEffect(() => {
        const fetchQuestion = async () => {
            const survey_id = "68084775ece92761170b9492";
            
            const response = await fetch(
                `${process.env.REACT_APP_AI_FORM_SERVER}/api/getQuestion?_=${new Date().getTime()}`,
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ survey_id }),
                }
            );

            
            const jsonData = await response.json();
            
            setSurveyID(jsonData[0]?.survey_id);
            setQuestionList(jsonData[0]?.details || []);
        };
        
        fetchQuestion();
    }, []);

    useEffect(() => {

        const fetchOptions = async () => {
            const fetchedOptions = [];

            await Promise.all(questionList.map(async (q, i) => {

                if ('optionsSrc' in q) {

                    const response = await fetch(q.optionsSrc);
                    const jsonData = await response.json();

                    fetchedOptions[i] = jsonData.map(option => {

                        if (typeof option == 'string') {
                            return {'en': option };
                        }

                        return option;
                    });
                }
            }))

            
            setQuestionList(prevList => prevList.map((q, i) => {
                if (fetchedOptions[i]) {
                    return {...q, options: fetchedOptions[i] };
                }
                return q;
            }));
        }

        const hasUnloadedOptions = questionList.some(q => 'optionsSrc' in q && !('options' in q));
        if (hasUnloadedOptions) {
            fetchOptions();
        }

    }, [questionList]);

    useEffect(() => {
        const initialValues = {};
        questionList.forEach(question => {
            const key = question.questions?.[language];

            if (question.qtype === "checkbox_multiple") {
                initialValues[key] = [];  // Empty array for multiple checkboxes
            } else {
                initialValues[key] = '';  // Default empty string
            }
        });

        setFormValues(initialValues);
    }, [questionList]);

    const setFormValue = (questionKey, value) => {
        if (value !== undefined && value !== null) {
            setFormValues(prev => ({
                ...prev,
                [questionKey]: value ?? ''
            }))
        }
        //setFormValues(prev => console.log(`${prev["Location"]} ||| ${prev["Time"]}`) || prev);
        //setFormValues(prev => console.log(prev) || prev);
    }

    const handleFormSubmit = async (e) => {
        e.preventDefault();

        const invalidCheckboxes = questionList.some(question => {
            if (question.qtype === "checkbox_single" || question.qtype === "checkbox_multiple") {
                const questionKey = question?.questions?.[language];

                // Ensure questionKey is valid
                if (!questionKey) {
                    console.log("Invalid question key:", question);
                    return false;  // Skip this question if no valid key
                }

                const selectedValues = formValues[questionKey];
                //console.log(`Checking question: ${questionKey}`, selectedValues);

                return question.required && (!selectedValues || selectedValues.length === 0);
            }
            return false;
        });

        if (invalidCheckboxes) {
            alert("Please select at least one option for required checkboxes.");
            return;
        }
        
        const confirmed = window.confirm("Are you sure you want to submit the form?");
        if (confirmed) {
            setFormValues(prev => {
                const sanitizedValues = {};
                for (const [key, value] of Object.entries(prev)) {
                    if (typeof value === 'string') {
                        sanitizedValues[key] = value.trim();
                    } else {
                        sanitizedValues[key] = value;
                    }
                }
                return sanitizedValues;
            });
            setSubmitted(true);
        }
    };

    useEffect(() => {
        if (isSubmitted) {
            const sendResponse = async () => {
                try {
                    const response = await fetch(`${process.env.REACT_APP_AI_FORM_SERVER}/api/formSubmit`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({
                            survey_id: surveyID, 
                            language: language,
                            response: formValues, 
                            submissionDate : moment().tz("Asia/Kuala_Lumpur").format()
                        }),
                    })
                   const data = await response.json();

                   if (data.success) {
                       window.alert('Success.');
                       window.location.href = '/formSubmit'; 
                   } else {
                       window.alert('Failed to submit form, please try again.');
                   }
               } catch (error) {
                   console.log('Error submitting form:', error);
                   window.alert('Failed to submit form, please try again.');
               }
            }

            if (formElemRef.current?.reportValidity()) {
                sendResponse();
            }
            setSubmitted(false);
        }
    }, [isSubmitted])


    return (
        <div>
            <Navbar currentPage='PickupForm' />
            <div className='form-container'>
                <br /><br /><br />

                <div className='header-container'>
                    <img src={header || '#'} alt='Header' className='header-image' />
                </div>

                <form ref={formElemRef} onSubmit={handleFormSubmit}>
                    <span style={{ color: 'red', fontSize: '0.8em' }}>* is a required field</span>
                    <hr />
                    
                    <div
                        style={{
                            backgroundColor: "#E6F2F2",
                            padding: "10px",
                            borderRadius: "5px",
                            marginBottom: "10px",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",  // Ensures uniform spacing
                        }}
                    >
                        <h3 style={{ margin: 0 }}>Case Rejected/Declined/Transferred Out in Island Hospital</h3>
                    </div>

                    {questionList.map((question, idx) => {
                        const questionKey = question.questions[language];
                        const formValue = formValues[questionKey];
                        const options = question.options?.map(option => option[language]) ?? [];
                        const otherOption = question.otherOption?.[language];
                        const required = question.required ?? false;

                        const inputProps = {
                            name: questionKey,
                            value: formValue,
                            required
                        }

                        return (
                            <div key={idx} style={{ marginBottom: '15px' }}>
                                <p>
                                    {idx+1}{'. '}{question.questions[language]}{' '}
                                    {question.required && <span style={{ color: 'red', fontWeight: 'bold' }}>*</span>}
                                </p>

                                {question.qtype === 'text' && (
                                    <input
                                        type="text"
                                        {...inputProps}
                                        onChange={e => setFormValue(questionKey, e.target.value)}
                                    />
                                )}

                                {question.qtype === 'text_area' && (
                                    <textarea
                                        {...inputProps}
                                        onChange={e => setFormValue(questionKey, e.target.value)}
                                        rows="4"
                                    />
                                )}

                                {question.qtype === 'radio' && (
                                    <RadioGroupInput
                                        {...inputProps}
                                        {...{options, otherOption}}
                                        onChange={result => setFormValue(questionKey, result)}
                                    />
                                )}

                                {question.qtype === 'select' && (
                                    <SelectInput
                                        {...inputProps}
                                        {...{options, otherOption}}
                                        onChange={result => setFormValue(questionKey, result)}
                                    />
                                )}

                                {question.qtype === 'date' && (
                                    <DatePicker
                                        selected={formValue}
                                        onChange={date => {
                                            date.setHours(0, 0, 0, 0);
                                            setFormValue(questionKey, date);
                                        }}
                                        required={required}
                                        wrapperClassName="datepicker"
                                    />
                                )}

                                {(question.qtype === 'checkbox_single' || question.qtype === 'checkbox_multiple') && (
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                                        {options.map((option, idx) => (
                                            <label key={idx} style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <input
                                                    type="checkbox"
                                                    name={questionKey} 
                                                    value={option}

                                                    onChange={(e) => {
                                                        if (question.qtype === 'checkbox_single') {
                                                            setFormValue(questionKey, e.target.checked);

                                                        } else {
                                                            if (e.target.checked) {
                                                                setFormValue(questionKey, [...(formValue ?? []), option]);
                                                            } else {
                                                                setFormValue(questionKey, formValue?.filter(opt => opt !== option) ?? []);
                                                            }
                                                        }
                                                    }}

                                                    checked={
                                                        question.qtype === 'checkbox_single'
                                                            ? formValues[questionKey] === option 
                                                            : formValues[questionKey]?.includes(option) ?? false
                                                    }
                                                    style={{ width: '14px', height: '14px' }}
                                                />
                                                {option}
                                            </label>
                                        ))}
                                    </div>
                                )}
                            </div>
                        )
                    })}

                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: '20px' }}>
                        <input type="submit" className="submitButton submitButton" value={buttonText[language].submit} />
                    </div>
                </form>
            </div>
        </div>
    );
}

export default CaseDismissedForm;

function RadioGroupInput({ name, options, otherOption, value, onChange, required = false }) {
    const [selectedOther, setSelectedOther] = useState(false);
    const [otherValue, setOtherValue] = useState('');

    const selectedOption = selectedOther ? otherOption : (value ?? '');

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
            { options.map((option, idx) => (  // Standard options
                <label key={idx} style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <input
                        type="radio"
                        name={name}
                        value={option}
                        onChange={e => {
                            setSelectedOther(false);
                            onChange(e.target.value);
                        }}
                        required={required}
                        checked={!selectedOther && selectedOption === option}
                    />
                    {option}
                </label>
            ))}

            { otherOption && (  // Other option with text input
                <label style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <input
                        type="radio"
                        name={name}
                        onChange={e => {
                            setSelectedOther(true);
                            onChange(otherValue);
                        }}
                        required={required}
                        checked={selectedOther}
                        style={{ marginRight: '5px' }}
                    />

                    <input
                        type="text"
                        name={name}
                        value={selectedOther ? value : otherValue}
                        onChange={e => {
                            setSelectedOther(true);
                            setOtherValue(e.target.value);
                            onChange(e.target.value);
                        }}
                        required={selectedOther && required}
                        placeholder={otherOption}
                    />
                </label>
            )}
        </div>
    );
}

function SelectInput({ name, options, otherOption, value, onChange, required = false }) {
    const [selectedOther, setSelectedOther] = useState(false);
    const [otherValue, setOtherValue] = useState('');

    const selectedOption = selectedOther ? otherOption : (value ?? '');
    const selectedValidOption = selectedOther || options.includes(selectedOption);

    const handleSelect = (e) => {
        const newOption = e.target.value;

        if (newOption === otherOption) {
            setSelectedOther(true);
            onChange(otherValue);

        } else {
            setSelectedOther(false);
            onChange(newOption);
        }
    }

    return (
        <div>
            <select
                name={name}
                value={selectedOption}
                onChange={handleSelect}
                required={required}
                style={{ marginBottom: '5px' }}
            >
                { !selectedValidOption && (  // Default unselectable option
                    <option value={value} hidden disabled>
                        {value}
                    </option>
                )}
                { options.map((option, idx) => (  // Standard options
                    <option value={option} key={idx}>
                        {option}
                    </option>
                ))}
                { otherOption && (  // "Other" option
                    <option value={otherOption}>
                        {otherOption}
                    </option>
                )}
            </select>

            { selectedOther && (  // "Other" option text input
                <input
                    type="text"
                    name={name}
                    value={value}
                    onChange={e => {
                        setOtherValue(e.target.value);
                        onChange(e.target.value);
                    }}
                    required={required}
                />
            )}
        </div>
    );
}